export enum P2PProviderWebhookStatus {
  New = 'new',
  Processed = 'processed',
  Error = 'error',
  Ignored = 'ignored',
}
